import EditCauseContainer from "../containers/EditCauseContainer";

const EditCausePage = () => {
  return (
    <EditCauseContainer />
  );
};

export default EditCausePage;
